import { usePushNotifications } from '@/hooks/usePushNotifications';
import { onMessage } from 'firebase/messaging';
import { useEffect } from 'react';
import { getFirebaseMessaging } from '../../../firebase/firebase';

export const PushNotificationSetup = () => {
  const { isSubscribed } = usePushNotifications();

  useEffect(() => {
    if (!isSubscribed || typeof window === 'undefined' || !('Notification' in window)) {
      return;
    }

    let unsubscribe: (() => void) | undefined;

    const setupOnMessage = async () => {
      const messaging = await getFirebaseMessaging();
      if (!messaging) {
        return;
      }

      unsubscribe = onMessage(messaging, (payload) => {
        const { title, body, icon } = payload.notification || {};
        const notificationOptions = {
          body,
          icon: icon || '/favicon.png',
          data: payload.data,
        };

        new Notification(title || 'New Notification', notificationOptions);
      });
    };

    setupOnMessage();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [isSubscribed]);

  return null;
};
